export default "__VITE_ASSET__Bq36BPtg__";